import { z } from "zod";
export const ELECTRIC_TURN_DEADLINE_MS = 30 * 60_000;
export const ELECTRIC_MODEL_TOOL_LIMIT = 300;
export const electricToolBatchSchema = z.object({
    key: z.string().uuid(),
    calls: z.array(z.object({ id: z.string().min(1), name: z.string().min(1),
        argumentsSha256: z.string().regex(/^[a-f0-9]{64}$/) }).strict()).min(1).max(300),
}).strict();
export const electricTurnIdentitySchema = z.object({ runId: z.string().min(1), sessionId: z.string().min(1),
    workerId: z.string().min(1), attemptNumber: z.number().int().positive() }).strict();
export const electricTurnAdmissionSchema = electricTurnIdentitySchema.extend({
    reservation: electricToolBatchSchema.optional(),
}).strict();
export const electricTurnReceiptSchema = electricTurnIdentitySchema.extend({ ok: z.literal(true),
    deadlineAt: z.number().int().positive(), maxToolCalls: z.literal(ELECTRIC_MODEL_TOOL_LIMIT),
    reservedToolCalls: z.number().int().min(0).max(ELECTRIC_MODEL_TOOL_LIMIT),
}).strict();
export function electricTurnDeadlineAt(startedAt) {
    if (!Number.isSafeInteger(startedAt) || startedAt <= 0)
        throw new Error("electric_turn_start_invalid");
    return startedAt + ELECTRIC_TURN_DEADLINE_MS;
}
